// eslint-disable-next-line no-unused-vars
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import BannerOwnerComponents from 'components/BannerOwner/bannerOwner.components';

const BannerOwnerPage = (props: any) => {
   return (
      <Fragment>
         <Helmet>
            <title>ชื่อเว็บไซต์</title>
         </Helmet>
            <BannerOwnerComponents {...props}/>
      </Fragment>
   );
};

export default BannerOwnerPage;
